var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css, keyframes } from "../../styled";
const DEFAULT_TIMEOUT = 300;
const bounceKeyFrames = keyframes `
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
`;
export const bounce = (timeout = DEFAULT_TIMEOUT, option) => css `
  animation: ${bounceKeyFrames} ${timeout}ms ${option ? option : ""} ease-out;
`;
const Container = styled.div `
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Bounce = styled.div `
  background: ${(props) => props.color || "currentColor"};
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  border-radius: 100%;
  display: inline-block;
  ${bounce(1400, "infinite")};
`;
const BounceOne = styled(Bounce) `
  animation-delay: -0.32s;
`;
const BounceTwo = styled(Bounce) `
  animation-delay: -0.16s;
`;
export const Spinner = (_a) => {
    var { size = "1rem", color } = _a, rest = __rest(_a, ["size", "color"]);
    return (React.createElement(Container, Object.assign({ "data-anchor": "loading-icon" }, rest),
        React.createElement(BounceOne, { color: color, size: size }),
        React.createElement(BounceTwo, { color: color, size: size }),
        React.createElement(Bounce, { color: color, size: size })));
};
export default Spinner;
